import { TUpsertUserPayload } from 'modules/settings/models';
import API from 'services/api';

export const upsertUser = ({ userId, payload }: TUpsertUserPayload) => {
  if (!!userId) {
    return API.put(`/api/users/${userId}/register-confirm-update`, payload);
  } else {
    return API.post('/api/users/register-confirm', payload);
  }
};
